export const CATEGORIES = [
  { name: "technology", color: "#1d4ed8", bgColor: "#93c5fd" },
  { name: "science", color: "#047857", bgColor: "#6ee7b7" },
  { name: "finance", color: "#b91c1c", bgColor: "#fca5a5" },
  { name: "society", color: "#a16207", bgColor: "#fde047" },
  { name: "entertainment", color: "#a21caf", bgColor: "#f0abfc" },
  { name: "health", color: "#0e7490", bgColor: "#67e8f9" },
  { name: "history", color: "#c2410c", bgColor: "#fdba74" },
  { name: "news", color: "#7e22ce", bgColor: "#d8b4fe" },
];

export const mediaQuery = {
  small: `@media screen and (max-width: 500px)`,
  mobile: `@media screen and (max-width: 768px)`,
  tablet: `@media screen and (max-width: 991px)`,
  laptop: `@media screen and (max-width: 1199px)`,
};
